import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import { useState } from "react";

const BulkUpdateModal = ({ onClose, onSuccess, actiontype, list, token }) => {
    const [role, setRole] = useState("Admin")
    const [parentEmailAddress, setParentEmailAddress] = useState("")
    const [loading, setLoading] = useState(false)
    const handleBulkChange = async () => {
        if (loading) return
        if(role === "Staff" && parentEmailAddress === ""){
            alert("Parent Email Address is required")
            return 
        }
        console.log(list, role)
        try {
            setLoading(true)
            const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkRoleChange/`, {
                method: 'PUT',
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ users: list, role , parentEmailAddress })
            })
            if (response.ok) {
                onSuccess?.();
                onClose();
            }
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-modal p-4">
            <div className="bg-surface rounded-lg shadow-floating max-w-2xl w-full max-h-[90vh] overflow-hidden">
                <div className="px-6 py-4 border-b border-border flex items-center justify-between">
                    <h2 className="text-xl font-heading font-semibold text-text-primary">Add New User</h2>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-background rounded-lg nav-transition"
                    >
                        <Icon name="X" size={20} color="var(--color-text-secondary)" />
                    </button>
                </div>
                <div className="p-6">
                    {actiontype === 'rolechange' &&
                        <div className="flex gap-4 flex-col">
                            <div>
                                <label>Update Role to: </label>
                                <select
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                    className="p-2 w-full rounded bordered"
                                >
                                    <option> Admin </option>
                                    <option> Staff </option>
                                    <option> Client </option>
                                </select>
                            </div>
                            {role === "Staff" &&
                                <div>
                                    <label>Enter Parent Email Address</label>
                                    <input
                                        type="text"
                                        value={parentEmailAddress}
                                        onChange={(e) => setParentEmailAddress(e.target.value)}
                                        className="border p-2 w-full rounded"
                                    />
                                </div>
                            }
                            <Button className="w-full text-white" loading={loading} onClick={() => handleBulkChange()}>
                                Submit
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default BulkUpdateModal;
